import React, { useContext, useEffect, useMemo } from 'react';
import { Table, ApplicationUIContext } from '@yuhuinc/ui-library';
import { Radio, Form, Input, Typography } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { toSentenceCase } from 'helpers/StringHelper';
import { hostIsCapreit, hostIsBoardwalk } from 'helpers/CurrentWindowLocation';

const { Title } = Typography;

const translate = (key) =>
  getTranslatedString(
    `landlordPortal.applicationManagement.inviteLeadToApply.additionalInformation.utilities.${key}`
  );

const COLUMNS = [
  {
    key: 'utility',
    title: translate('utility'),
    dataIndex: 'name',
  },
  {
    key: 'landlord',
    align: 'center',
    title: translate('landlord'),
    render(_, row) {
      return (
        <Form.Item name={['utilities', row.key, 'paid_by']}>
          <Radio.Group>
            <Radio value="landlord" />
          </Radio.Group>
        </Form.Item>
      );
    },
  },
  {
    key: 'tenant',
    align: 'center',
    title: translate('tenant'),
    render(_, row) {
      return (
        <Form.Item name={['utilities', row.key, 'paid_by']}>
          <Radio.Group>
            <Radio value="tenant" />
          </Radio.Group>
        </Form.Item>
      );
    },
  },
];

const defaultValues = {
  heat: {
    paid_by: null,
  },
  water: {
    paid_by: null,
  },
  electricity: {
    paid_by: null,
  },
};

const mapUtilitiesToRows = (utilities) =>
  Object.entries(utilities).map(([key, value]) => {
    let name = translate(key);

    if (name.includes('MISSING')) {
      name = toSentenceCase(key);
    }

    return {
      key: key,
      name: name,
      ...value,
    }
  });

const Utilities = ({ selectedUnit, mode }) => {
  const form = Form.useFormInstance();
  const { isMobile } = useContext(ApplicationUIContext);
  const utilities = Form.useWatch('utilities', form);
  const rows = useMemo(() => mapUtilitiesToRows(utilities || {}), [utilities]);

  useEffect(() => {
    if (mode === 'create') {
      let initialValues = {
        ...defaultValues,
        ...(selectedUnit?.property_services_and_utilities?.utilities || {}),
      };

      if (hostIsCapreit() || hostIsBoardwalk()) {
        initialValues = { ...(selectedUnit?.property_services_and_utilities?.utilities || {}) };
      }

      form.setFieldsValue({ utilities: initialValues });
    }
  }, [selectedUnit]);

  return (
    <>
      <Title level={isMobile ? 4 : 5} style={{ marginTop: 0, marginBottom: 20 }}>
        {translate('title')}
      </Title>

      {/* it seems an associated Form.Item needs to be mounted/registered for programmatic updates to work */}
      <Form.Item name="utilities" hidden>
        <Input />
      </Form.Item>

      <Table
        dataSource={rows}
        rowKey="name"
        columns={COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={{ hideOnSinglePage: true }}
      />
    </>
  );
};

export default Utilities;
